import { Flex, Space, Typography } from 'antd';
import { BackButton } from '@/shared/components/buttons/BackButton';

const { Text, Title } = Typography;

export const AdminPanelLayoutV2 = ({ title, subtitle, fallbackTo, fallbackOptions, children }) => {
  return (
    <div style={{ width: '90%', margin: '0 auto' }}>
      <Flex vertical gap={32}>
        <Space size={0} direction='vertical'>
          <BackButton fallbackTo={fallbackTo} fallbackOptions={fallbackOptions} />
          <Title level={2} style={{ margin: 0, fontWeight: 700 }}>{title}</Title>
          <Text type='secondary' strong style={{ fontSize: '1.2em' }}>{subtitle}</Text>
        </Space>
        {children}
      </Flex>
    </div>
  );
};
